import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ReminderListDatastore } from '../datasources/personal_reminder_list_datasource';
import { ORM } from 'utility-ts-orm';

angular
  .module('data-ng-personal-reminders')
  .factory(
    'loadAllReminderDateRangeCommand',
    (defineCommand: IDefineCommand, $http: ng.IHttpService, reminderListDatastore: ReminderListDatastore): ICommand => {
      return defineCommand(
        'loadAllReminderDateRangeCommand',
        (deferred: ng.IDeferred<IQuery[]>, formattedTimeRange: any): void => {
          const data = {
            end_dt: formattedTimeRange.end,
            start_dt: formattedTimeRange.start,
            status: 'ACTIVE'
          };

          $http
            .get(`event/todos/`, {
              params: data
            })
            .then((response: any) => {
              reminderListDatastore.write(response.data);
              deferred.resolve(ORM.run(reminderListDatastore));
            })
            .catch((error: any) => {
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/commands/load_all_reminder_date_range_command.ts